import { VerificationStatus } from "shared/types";
import { has } from "shared/utils";
import { Lock01 } from "untitledui-js-base";
import { AuditSummaryFlag } from "views/applications-id/components/ApplicantsTable/components/AuditSummaryFlag";
import { Cell } from "views/applications-id/components/ApplicantsTable/components/Cell";
import { ReportStatusBadge } from "views/applications-id/components/ApplicantsTable/components/ReportStatusBadge";
import {
  FullApplicant,
  Verification
} from "views/applications-id/components/ApplicantsTable/types";

export const CriminalReportSection = ({
  hasClearaCategorization,
  applicant,
  isApplicant,
  verification,
  ruleBased,
  inProgress,
  hasAuditFlagEnabled
}: {
  hasAuditFlagEnabled: boolean;
  hasClearaCategorization?: boolean;
  applicant: FullApplicant;
  isApplicant: boolean;
  ruleBased?: boolean;
  inProgress: boolean;
  verification: Verification;
}) => {
  return (
    <>
      {hasClearaCategorization ? (
        <>
          <Cell isFirst isDataCell className="relative">
            {verification.summary?.require_approval ? (
              <Lock01 className="stroke-content-100 h-5 w-5" />
            ) : has(verification.summary?.total_felony_records) ? (
              verification.summary.total_felony_records
            ) : hasAuditFlagEnabled ? (
              <AuditSummaryFlag
                audit_summary_flags={applicant.audit_summary_flags}
              />
            ) : (
              "-"
            )}

            <ReportStatusBadge
              verificationStatus={verification.status}
              applicantStatus={applicant.application_status}
              isRequireApproval={verification.summary?.require_approval}
              executionMode={verification.settings?.execution_mode}
            />
          </Cell>
          <Cell isDataCell>
            {verification.summary?.require_approval ? (
              <Lock01 className="stroke-content-100 h-5 w-5" />
            ) : has(verification.summary?.total_misdemeanor_records) ? (
              verification.summary.total_misdemeanor_records
            ) : hasAuditFlagEnabled ? (
              <AuditSummaryFlag
                audit_summary_flags={applicant.audit_summary_flags}
              />
            ) : (
              "-"
            )}
          </Cell>
          <Cell isDataCell>
            {verification.summary?.require_approval ? (
              <Lock01 className="stroke-content-100 h-5 w-5" />
            ) : has(verification.summary?.total_other_criminal_records) ? (
              verification.summary.total_other_criminal_records
            ) : hasAuditFlagEnabled ? (
              <AuditSummaryFlag
                audit_summary_flags={applicant.audit_summary_flags}
              />
            ) : (
              "-"
            )}
          </Cell>
        </>
      ) : (
        <>
          <Cell isFirst isDataCell className="relative">
            {verification.summary?.require_approval ? (
              <Lock01 className="stroke-content-100 h-5 w-5" />
            ) : has(verification.summary?.total_criminal_records) ? (
              verification.summary.total_criminal_records
            ) : hasAuditFlagEnabled ? (
              <AuditSummaryFlag
                audit_summary_flags={applicant.audit_summary_flags}
              />
            ) : (
              "-"
            )}

            <ReportStatusBadge
              verificationStatus={verification.status}
              applicantStatus={applicant.application_status}
              isRequireApproval={verification.summary?.require_approval}
              executionMode={verification.settings?.execution_mode}
            />
          </Cell>
          <Cell isDataCell>
            {verification.summary?.require_approval ? (
              <Lock01 className="stroke-content-100 h-5 w-5" />
            ) : has(verification.summary?.total_traffic_records) ? (
              verification.summary.total_traffic_records
            ) : hasAuditFlagEnabled ? (
              <AuditSummaryFlag
                audit_summary_flags={applicant.audit_summary_flags}
              />
            ) : (
              "-"
            )}
          </Cell>
        </>
      )}
      <Cell
        isDataCell
        check={
          verification.summary?.require_approval ||
          verification.status === VerificationStatus.Failed
            ? null
            : verification.status === VerificationStatus.NoDataAvailable
              ? null
              : isApplicant &&
                  !ruleBased &&
                  !inProgress &&
                  typeof applicant.criteria_check_settings.sex_offender_check
                    ?.importance === "number"
                ? applicant.criteria_check_settings.sex_offender_check.check
                : null
        }
      >
        {verification.summary?.require_approval ? (
          <Lock01 className="stroke-content-100 h-5 w-5" />
        ) : has(verification.summary?.total_sex_offender_records) ? (
          verification.summary.total_sex_offender_records
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
      </Cell>
      <Cell isDataCell>
        {verification.summary?.require_approval ? (
          <Lock01 className="stroke-content-100 h-5 w-5" />
        ) : has(verification.summary?.total_ofac_records) ? (
          verification.summary.total_ofac_records
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
      </Cell>
    </>
  );
};
